import Cookies from 'js-cookie';

const trackClosing = (heading: string) => {
    window?.dataLayer?.push({
        event: 'engine',
        event_category: 'engine_close_card',
        event_action: 'close',
        event_label: heading,
    });
};

function closeDynamicCard(): void {
    const closableCard = (card: Element): void => {
        const closeBtn = card.querySelector('.sgw-market-card__close-button') as HTMLElement;

        function findClosestLayoutItem(startEl: HTMLElement): HTMLElement | null {
            let currentEl: HTMLElement | null = startEl.parentNode as HTMLElement | null;
            while (currentEl && !currentEl.classList.contains('sgw-layout-item')) {
                currentEl = currentEl.parentNode as HTMLElement | null;
            }
            return currentEl;
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', (e: Event) => {
                e.preventDefault();
                const parent = (e.currentTarget as HTMLElement).closest('[data-closable]') as HTMLElement;
                if (parent) {
                    const closestContainer = findClosestLayoutItem(parent);
                    const heading = parent.querySelector('h2, h3, h4')?.textContent ?? '';
                    const uniqueId = parent.getAttribute('data-closable');

                    if (closestContainer && closestContainer.childElementCount === 1) {
                        closestContainer.remove();
                    } else {
                        parent.remove();
                    }
                    trackClosing(heading);

                    Cookies.set(`eika-closedElement__${uniqueId}`, 'true', { expires: 84 });
                }
            });
        }
    };

    const availableElements = document.querySelectorAll('[data-closable]');
    if (availableElements) {
        availableElements.forEach(closableCard);
    }
}

export default closeDynamicCard;
